jQuery(document).ready(function ($) {
	"use strict";

	/**
	 * Toggle main menu
	 */
	$('.icon-burger').on('click', function () {
		$('body').toggleClass('is-menu-open');
		closeSubMenu();
		$('.site-header>.js-searchform').hide();
		$('.js-search').removeClass('is-active');
	});

	$('.main-menu li:not(.js-li-search) > a').on('click', function () {
		$('body').removeClass('is-menu-open');
	});

	// autoclose mobile menu when increasing window width
	function closeMobileMenu() {
		$('.main-menu .sub-menu').css('display', '');
		if ($(window).width() > 1199) {
			if ($('body').hasClass('is-menu-open')) {
				$('.icon-burger').trigger('click');
			}
		}
	}

	function closeSubMenu() {
		$('.main-menu .sub-menu').slideUp().closest('.menu-item-has-children').removeClass('active');
	}

	$(window).on('resize', function (e) {
		closeMobileMenu();
	});


	/**
	 * Toggle mobile sub menu
	 */
	$('.main-menu .menu-item-has-children>button').on('click', function (e) {
		const el = $(this).parent(),
			topEl = el.parent();
		if ($(window).width() < 1200) {
			e.stopPropagation();
			if (el.hasClass('active')) {
				el.removeClass('active');
				el.children('.sub-menu').slideUp();
			} else {
				topEl.find('.sub-menu').slideUp();
				topEl.find('.menu-item-has-children').removeClass('active');
				el.addClass('active');
				el.children('.sub-menu').slideDown();
			}
		}
	});
	$('.footer-menu .menu-item-has-children>button').on('click', function (e) {
		const el = $(this).parent(),
			topEl = el.parent();
		if ($(window).width() < 640) {
			e.stopPropagation();
			if (el.hasClass('active')) {
				el.removeClass('active');
				el.children('.sub-menu').slideUp();
			} else {
				topEl.find('.sub-menu').slideUp();
				topEl.find('.menu-item-has-children').removeClass('active');
				el.addClass('active');
				el.children('.sub-menu').slideDown();
			}
		}
	});

	//Change position for drop down
	$(function () {
		$(".main-menu .menu-item-has-children").on("mouseenter mouseleave", function (e) {
			if ($(".sub-menu", this).length) {
				let elm = $(".sub-menu", this);
				let off = elm.offset();
				let l = off.left;
				let w = elm.width();
				let docW = $(window).width();

				let isEntirelyVisible = l + w <= docW;
				if (l < 0) {
					$(elm).addClass("dropdown-left");
				} else {
					$(elm).removeClass("dropdown-left");
				}
				if (!isEntirelyVisible) {
					$(elm).addClass("dropdown-reverse");
				} else {
					$(elm).removeClass("dropdown-reverse");
				}
			}
		});
	});
});
